import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetDocumentManagementDetailByID,
  POST_GetDocumentManagementViewHistory,
  POST_DocumentManagementRewiseInsert,
} from "../../../helpers/url_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const ReviseDocumentManagement = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [documentManagementFilePathset, setDocumentManagementFilePath] =
    useState(null);
  const [documentManagementFilePathFile, setDocumentManagementFilePathFile] =
    useState(null);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    if (PrimaryIdParam) {
      GetDocumentManagementDetail();
    }
  }, []);

  const validationSchema = Yup.object().shape({
    DocumentName: Yup.string()
      .trim()
      .required("Document Name is required field"),

    Description: Yup.string().trim().required("Description is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DocumentManagementIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ParentDocumentManagementIDEncrypted: "",
      DocumentName: "",
      Description: "",
      DocumentManagementFilePath: "",
      DocumentManagementFilePathURL: "",
      DocumentManagementFileName: "",
      DocumentFilePath: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      DocumentManagementIDEncrypted,
      ParentDocumentManagementIDEncrypted,
      DocumentManagementFilePath,
      DocumentManagementFilePathURL,
      DocumentManagementFileName,
      DocumentFilePath,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      documentManagementFilePathset == "" &&
      DocumentManagementFilePathURL == ""
    ) {
      formik.setFieldError(
        "DocumentManagementFilePath",
        "Please select a valid Document Management File",
      );
      formik.setFieldTouched("DocumentManagementFilePath", true);
      return false;
    }
    setIsLoading(true);
    let formData = new FormData();

    formData.append(
      "DocumentManagementIDEncrypted",
      DocumentManagementIDEncrypted,
    );
    formData.append("DocumentName", values?.DocumentName);
    formData.append(
      "ParentDocumentManagementIDEncrypted",
      values?.ParentDocumentManagementIDEncrypted
        ? values?.ParentDocumentManagementIDEncrypted
        : "0",
    );

    formData.append(
      "Description",
      values?.Description ? values?.Description : "",
    );
    formData.append(
      "DocumentManagementFilePath",
      documentManagementFilePathset,
    );
    formData.append("DocumentManagementFilePathURL", values?.DocumentFilePath);
    formData.append(
      "DocumentManagementFileName",
      values?.DocumentManagementFileName,
    );
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);

    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    postFormData(POST_DocumentManagementRewiseInsert, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/document-management");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetDocumentManagementDetail = () => {
    setIsLoading(true);
    post(POST_GetDocumentManagementDetailByID, {
      DocumentManagementIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadDocumentManagementFilePath = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      if (!file) {
        setDocumentManagementFilePath(null);
        setDocumentManagementFilePathFile(null);
        warningMessage("Select valid file!");
      } else {
        setDocumentManagementFilePath(file);
        setDocumentManagementFilePathFile(URL.createObjectURL(file));
      }
    }
  };

  const [
    documentManagementReviseHistoryList,
    setDocumentManagementReviseHistoryList,
  ] = useState([]);
  const [
    documentManagementReviseHistoryModal,
    setDocumentManagementReviseHistoryModal,
  ] = useState(false);

  const DocumentManagement_History = () => {
    setIsLoading(true);
    setDocumentManagementReviseHistoryList("");
    setDocumentManagementReviseHistoryModal(true);

    let payload = {
      DocumentManagementIDEncrypted: DocumentManagementIDEncrypted,
      ParentDocumentManagementIDEncrypted: ParentDocumentManagementIDEncrypted,
    };
    post(POST_GetDocumentManagementViewHistory, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setDocumentManagementReviseHistoryList(response?.List);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Revise Document Management</h4>
              <div className="d-flex align-items-center">
                <div>
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      DocumentManagement_History();
                    }}
                  >
                    View Revise History
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Field
                      label="Document Name"
                      name="DocumentName"
                      placeholder={"Enter Document Name"}
                      component={CustomInput}
                      required
                      maxLength={2000}
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "DocumentName",
                          capitalizeString(e?.target?.value),
                        );
                      }}
                    />
                  </Col>

                  <Col lg={4}>
                    <div className="d-flex justify-content-between">
                      <label className="mb-1">
                        Document Management File Path{" "}
                      </label>
                      {DocumentManagementFilePath ? (
                        <Link
                          to="#"
                          className="fs-14"
                          onClick={() => {
                            window.open(DocumentManagementFilePath, "_blank");
                          }}
                        >
                          <i className="fa fa-download"></i> Download
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                    <input
                      type="file"
                      id="DocumentManagementFilePath"
                      className="form-control form-control-sm"
                      // accept="image/png, image/gif, image/jpeg,.xls, .xlsx,.doc,.docx,application/pdf"
                      onChange={uploadDocumentManagementFilePath}
                    />
                    {/* <label htmlFor="DocumentManagementFilePath" name=""></label> */}
                    <ErrorMessage
                      name="DocumentManagementFilePath"
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Description"
                      name="Description"
                      placeholder={"Enter Description"}
                      component={CustomTextArea}
                      rows={5}
                      maxLength={2000}
                      required
                    />
                  </Col>
                </Row>

                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={documentManagementReviseHistoryModal}
          onHide={setDocumentManagementReviseHistoryModal}
          size="xl"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div>
              <Modal.Header>
                <Modal.Title>Document Management Revise History</Modal.Title>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() =>
                      setDocumentManagementReviseHistoryModal(false)
                    }
                  ></button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="Document-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="Document-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="thead-light">
                        <tr role="row">
                          <th style={{ width: "5%" }}>Sr No</th>
                          <th style={{ width: "20%" }}>Document Name</th>
                          <th style={{ width: "20%" }}>Created Date</th>
                          <th style={{ width: "25%" }}>File Name</th>
                          <th style={{ width: "15%" }}>Current Version</th>
                          <th style={{ width: "15%", textAlign: "left" }}>
                            View File
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentManagementReviseHistoryList?.length > 0 ? (
                          documentManagementReviseHistoryList?.map(
                            (item, indx) => (
                              <>
                                <tr role="row" className="odd">
                                  <td style={{ textAlign: "center" }}>
                                    {indx + 1}
                                  </td>
                                  <td>{item?.DocumentName}</td>
                                  <td>{item?.CreatedDate}</td>
                                  <td>{item?.DocumentManagementFileName}</td>
                                  <td>
                                    {item?.IsCurrentVersion ? "Yes" : "No"}
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.DocumentManagementFilePath
                                            ? item?.DocumentManagementFilePath
                                            : "",
                                          "_blank",
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td>
                                </tr>
                              </>
                            ),
                          )
                        ) : (
                          <tr>
                            <td
                              colSpan={4}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div className="mt-1 ml-1 mb-2">
                                {"No Record Found..."}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal.Body>
            </div>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default ReviseDocumentManagement;
